export default __webpack_public_path__ + "static/media/Icon-File-Outline-Folder-Full.d4488f8c.svg";